import type { ReactNode } from "react";

import { useFeatureGate } from "@/hooks/use-feature-gate";
import type { FeatureKey } from "@/lib/features";

import { UpgradePrompt } from "./UpgradePrompt";

interface FeatureGateProps {
  feature: FeatureKey;
  children: ReactNode;
  fallback?: ReactNode;
  featureName?: string;
}

export function FeatureGate({
  feature,
  children,
  fallback,
  featureName,
}: FeatureGateProps) {
  const { hasFeature, requiredPlan, isResolving } = useFeatureGate(feature);

  // While the org context is still resolving we don't yet know whether the
  // feature is available. Render children so their own loading UI takes over
  // — otherwise the upgrade prompt flashes before the definitive answer.
  if (isResolving || hasFeature) {
    return <>{children}</>;
  }

  return (
    <>
      {fallback ?? (
        <UpgradePrompt requiredPlan={requiredPlan} featureName={featureName} />
      )}
    </>
  );
}
